export default {
  complianceName: { type: 'string', required: true },
  complianceType: { type: 'enum', required: true },
  isAllEmployee: { type: 'boolean', required: false },
  isSignatureRequired: { type: 'boolean', required: false },
  gracePeriodDays: {
    type: 'enum',
    required: {
      value: true,
      when: {
        $isSignatureRequired: {
          in: [true, null, undefined],
        },
      },
    },
  },

  positionIds: {
    type: 'string',
    required: {
      value: true,
      when: {
        _and_: [
          {
            $isAllEmployee: {
              in: [false, null, undefined],
            },
          },
          {
            $offices: {
              empty: true,
            },
          },
          {
            $relatedEmployeeContractTypes: {
              empty: true,
            },
          },
          {
            $businessRegistrationCountries: {
              empty: true,
            },
          },
          {
            $assignments: {
              empty: true,
            },
          },
        ],
      },
    },
  },

  offices: {
    type: 'string',
    required: {
      value: true,
      when: {
        _and_: [
          {
            $isAllEmployee: {
              in: [false, null, undefined],
            },
          },
          {
            $positionIds: {
              empty: true,
            },
          },
          {
            $relatedEmployeeContractTypes: {
              empty: true,
            },
          },
          {
            $businessRegistrationCountries: {
              empty: true,
            },
          },
          {
            $assignments: {
              empty: true,
            },
          },
        ],
      },
    },
  },
  relatedEmployeeContractTypes: {
    type: 'string',
    required: {
      value: true,
      when: {
        _and_: [
          {
            $isAllEmployee: {
              in: [false, null, undefined],
            },
          },
          {
            $positionIds: {
              empty: true,
            },
          },
          {
            $offices: {
              empty: true,
            },
          },
          {
            $businessRegistrationCountries: {
              empty: true,
            },
          },
          {
            $assignments: {
              empty: true,
            },
          },
        ],
      },
    },
  },
  businessRegistrationCountries: {
    type: 'string',
    required: {
      value: true,
      when: {
        _and_: [
          {
            $isAllEmployee: {
              in: [false, null, undefined],
            },
          },
          {
            $positionIds: {
              empty: true,
            },
          },
          {
            $offices: {
              empty: true,
            },
          },
          {
            $relatedEmployeeContractTypes: {
              empty: true,
            },
          },
          {
            $assignments: {
              empty: true,
            },
          },
        ],
      },
    },
  },
  assignments: {
    type: 'enum',
    required: {
      value: true,
      when: {
        _and_: [
          {
            $isAllEmployee: {
              in: [false, null, undefined],
            },
          },
          {
            $positionIds: {
              empty: true,
            },
          },
          {
            $offices: {
              empty: true,
            },
          },
          {
            $relatedEmployeeContractTypes: {
              empty: true,
            },
          },
          {
            $businessRegistrationCountries: {
              empty: true,
            },
          },
        ],
      },
    },
  },

  paths: {
    type: 'array',
    maxSize: 1,
    required: true,
  },
};
